import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useLoading } from 'hooks/useLoading';
import { Box, Input, Button, Flex, FormLabel } from '@chakra-ui/react';
import Heading from 'components/Heading/Heading';
import { post } from 'api/httpClient';
import { fetchToken, getToken } from 'api/auth';
import { notifyError } from 'api/notifications';
import { useSession } from 'context/SessionContext';
import { useUserSession } from 'context/UserContext';

const HomePage: React.FC = () => {
  const [userInput, setUserInput] = useState<string>('');
  const [isSubmitDisabled, setIsSubmitDisabled] = useState<boolean>(true);
  const history = useHistory();
  const { startLoading, stopLoading, LoadingSpinner } = useLoading();
  const { data, setData } = useSession();
  const { setUserData } = useUserSession()                                          
  const { search } = useLocation();
  const [showPage, setShowPage] = useState<boolean>(false);

  useEffect(() => {
    let isMounted = true;
    
    const regex = /[?&]data=([^&#]*)/;
    const match = regex.exec(search);
    const encryptString = match ? match[1] : null;

    if (!encryptString) history.push('/not-found');

    const initialData = {
      encryptString,
      answerQuestionnaires: []
    };

    if (isMounted) {
      setData(() => ({
        ...initialData,
      }));
    }

    /**
     * Fetches and stores the authentication token required for accessing external APIs.
     * This token is essential for all subsequent API calls and must be obtained before
     * making any requests to protected endpoints.
     */
    const getToken = async () => {
      try {
        startLoading()
        await fetchToken().finally(() => {
          setShowPage(true);
          stopLoading();
        });
      } catch (error) {
         stopLoading();
        if (isMounted) {
          notifyError('Erro ao obter token.');
        }
      }
    };

    getToken();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    const token = getToken();
    const isDisabled = !token || userInput.length < 9;

    setIsSubmitDisabled(isDisabled);
  }, [userInput])

  const handleSubmit = async () => {
    let isMounted = true;
    startLoading();

    try {
      const response = await post(`/v1/Questionnaire/ValidateQuestionnaire`, {
        EncryptString: data.encryptString,
        nif: userInput,
      });

      response.encryptString = data.encryptString;
      
      if (isMounted) {
        setUserData(response);
        setData(() => ({
          ...data,
          nif: userInput
        }));
        history.push('/questionarios');
      }
    } catch (error) {
      // Handle error if needed
    } finally {
      if (isMounted) {
        stopLoading();
      }
    }
  };

  return (
    <>
    {showPage && (
      <Flex
        minH="calc(100vh - 300px)"
        maxW="800px"
        m="0 auto"
        alignItems="center"
        justifyContent="center"
      >
        <Box>
          <Box>
            <Heading title="Validação" />
          </Box>

          <Box>
            <Flex
              flexDir={['column', 'row']}
              justify={['flex-start', 'space-between']}
              align={['flex-start', 'center']}
              maxW={['100%', '860px']}
            >
              <FormLabel
                fontWeight={400}
                p={['0 0 5px 0', '0']}
                margin={['unset', '0 10px 0 0']}
                maxW={['100%', '200px']}
                color="brand.fontColors.primary"
                htmlFor="validation"
              >
                Digite o seu NIF
              </FormLabel>
              <Input
                id="validation"
                size="lg"
                width={['100%', 'calc(860px - 220px)']}
                borderRadius="0px"
                bg="#E4EAEB"
                _hover={{ bg: '#F4F8F8' }}
                placeholder="NIF"
                value={userInput}
                onChange={e => setUserInput(e.target.value)}
              />
            </Flex>

            <Box
              display="flex"
              alignItems="center"
              justifyContent="flex-end"
              pt={35}
            >
              <Button
                variant="primary"
                onClick={handleSubmit}
                disabled={isSubmitDisabled}
              >
                <span>Verificar</span>
              </Button>
            </Box>
          </Box>
        </Box>
      </Flex>)}
      <LoadingSpinner />
    </>
  );
};

export default HomePage;
